import { differenceInDays, startOfDay } from 'date-fns'

export const getCaseAge = (createdAt: string) => {
  const createdAtDate = new Date(createdAt)
  const startOfCreatedAt = startOfDay(createdAtDate)
  const today = startOfDay(new Date())

  return differenceInDays(today, startOfCreatedAt)
}
